export const OK = 200;
export const BAD_REQUEST = 400;
export const UNAUTHORIZED = 401;
export const FORBIDDEN = 403;
export const NOT_FOUND = 404;
export const METHOD_NOT_ALLOWED = 405;
export const UNPROCESSABLE_ENTITY = 422;
export const TOO_MANY_REQUESTS = 429;
export const INVALID_TOKEN = 498;
export const INTERNAL_SERVER_ERROR = 500;
export const COMMUNICATION_LINKS_FAILURE = 502;
